naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'
React = require 'react'
MemberAvatar = require 'views/member/member-avatar-react'
AutoCompleteMultiBoardGuestAlert = require 'views/organization/invite-member-autocomplete-multi-board-guest-alert'
t = require('views/internal/recup-with-helpers')('select_member')
l = require 'lib/localize'
trackUe = require 'debug/trackUe'
OrgFeatures = require 'data/org-features'
{ debounce } = require 'underscore'

module.exports = class AutocompleteMemberAvatar extends React.Component
  displayName: 'AutocompleteMemberAvatar'

  constructor: (props) ->
    super(props)
    @onRemoveClick = @onRemoveClick.bind(@)
    @onMouseDown = @onMouseDown.bind(@)
    @onMouseOver = debounce @onMouseOver.bind(@)
    @state =
      mgbAlertSeen: false

  render: t.renderable ->
    {
      member
      onRemoveClick,
      onMouseDown,
      displayDetails,
      displayOrg,
      displayUsername,
      disabled,
      activeMember,
      onShowMultiBoardGuestAlert,
    } = @props

    {
      active,
      username,
      email,
      confirmed,
      joined,
      fullName,
      memberType,
      idOrganizations,
      wouldBecomeBillableGuest,
      hasError,
      blockInvite,
    } = member

    isClickable = @isClickable()

    if displayUsername
      title = "#{ fullName } (#{ username })"
    else
      title = fullName || email

    # using mousedown instead of click on the option allows us to
    # select the option and then have the input blur happen afterwards
    t.div ".autocomplete-option", {
      onMouseDown: @onMouseDown,
      onMouseOver: @onMouseOver,
      class: t.classify({
        disabled: !isClickable
        active: activeMember && isClickable
        owned: @props.displayOrg?.owned()
        'has-links': wouldBecomeBillableGuest && !disabled
        'has-error': hasError || blockInvite
      })
    }, =>
      t.div ".member-container", =>
        if displayDetails
          t.div '.member', =>
            t.createElement MemberAvatar, @props.member

        t.div '.member-info', ->
          t.div '.full-name', ->
            t.text title

          if displayOrg? && displayDetails && idOrganizations && displayOrg.id in idOrganizations
            t.span '.quiet.sub-name', {
              style:
                marginRight: 4
              }, ->
              t.text displayOrg.get('displayName')

          if displayDetails
            if joined
              if memberType? == 'ghost'
                t.span '.quiet.sub-name', ->
                  t.text l('invited')
              else
                t.span '.quiet.sub-name', ->
                  t.text "(#{l('joined')})"
            else
              if !confirmed
                t.span '.quiet.sub-name', ->
                  t.format 'unconfirmed-user'
              else if !active
                t.span '.quiet.sub-name', ->
                  t.format 'inactive-account'
        if onRemoveClick
          t.a '.icon-sm .icon-close', { onClick: @onRemoveClick, href: '#' }
      if @showMultiBoardGuestAlert()
        t.div '.multi-board-guest-autocomplete-alert', ->
          t.createElement AutoCompleteMultiBoardGuestAlert, { displayOrg }

  showMultiBoardGuestAlert: ->
    {
      onRemoveClick
      member
      disabled
      displayOrg
    } = @props
    return (
      !onRemoveClick &&
      member.wouldBecomeBillableGuest &&
      !disabled
    )

  isClickable: ->
    availableLicenseCount = @props.displayOrg?.getAvailableLicenseCount()
    !@props?.disabled &&
      !(@props?.member?.wouldBecomeBillableGuest && !@props.displayOrg?.owned()) &&
      (
        (@props?.member?.wouldBecomeBillableGuest && availableLicenseCount > 0) ||
        (!@props?.member?.wouldBecomeBillableGuest)
      )

  onMouseDown: (e) ->
    {
      onRemoveClick
      onShowMultiBoardGuestAlert
      member
    } = @props

    wasRemoveClicked = e.target.className.indexOf('icon-close') != -1

    # If this is a red lozenge, show the alert on click
    if onShowMultiBoardGuestAlert? && member.blockInvite && !wasRemoveClicked
      onShowMultiBoardGuestAlert(true)

    if !@isClickable()
      e.preventDefault()
    else if @props?.onMouseDown
      @props.onMouseDown(e)

  onMouseOver: (e) ->
    if !@state.mgbAlertSeen && @showMultiBoardGuestAlert()
      @setState
        mgbAlertSeen: true
      trackUe(
        'invite to board'
        'shows'
        'mbg alert'
        ''
        ''
        'by hovering over the guest in the dropdown'
        {
          'organizationid': @props.displayOrg?.id
          'memberid': @props.member.id
        }
      )


  onRemoveClick: (e) ->
    {
      onRemoveClick
      onShowMultiBoardGuestAlert
      member
    } = @props
    if member.blockInvite && onShowMultiBoardGuestAlert?
      onShowMultiBoardGuestAlert(false)
    onRemoveClick()



// WEBPACK FOOTER //
// ./app/scripts/views/organization/invite-member-autocomplete-avatar.coffee